/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import TimelineEvent from 'solis/logic/board/zone/timeline/event';


export default class DestroyEvent extends TimelineEvent
{
  findNextDate ()
  {
    this.date = this.zone.getBoard().cass.destroyDate;
  }


  getLabel ()
  {
    return 'board is destroyed';
  }


};
